module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="quizAnswerResponseWrapper" class="xDialogWrapper xAnswerResponseWrapper';
 if(typeof(correctClass)!=="undefined"){ 
__p+=' '+
((__t=( correctClass ))==null?'':_.escape(__t))+
'';
 } 
__p+='">\n	<div id="quizDialogContent" class="xDialogContent">\n\n		';
 if(typeof(prefixContent)!=="undefined"){ 
__p+=''+
((__t=( prefixContent ))==null?'':__t)+
'<br><br>';
 } 
__p+='\n\n		';
 if(typeof(responses)!=="undefined"){
			for(var i=0,n=responses.length;i<n;i++){ 
__p+='\n				<div class="xAnswerResponse">'+
((__t=( responses[i] ))==null?'':__t)+
'</div>\n			';
 }
		} 
__p+='\n\n	</div>\n	<div id="quizDialogFooter" class="xDialogFooter">\n		<br/>\n		<a href="#" class="xButton xActionContinue"><span>'+
((__t=( NGX.lang.get('buttons.continue') ))==null?'':_.escape(__t))+
'</span></a>\n	</div>\n</div>\n';
}
return __p;
};
